function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Heading from '../Heading';
import { useLocation, useNavigate, useOutlet } from 'react-router';
import { useSearchQueryState } from '@/hooks/usePaginationQueryState';
import SearchInput from '../SearchInput';
import DashboardLayout from './DashboardLayout';
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { NativeSelect } from '@mantine/core';
import { WebRoutes } from '@/utils/constants';
import styles from './LogsLayout.module.scss';
export var LogContext = /*#__PURE__*/ React.createContext({
    search: '',
    setIsSearching: function() {}
});
export default function LogsLayout(param) {
    var children = param.children;
    var intl = useIntl();
    var _useSearchQueryState = _sliced_to_array(useSearchQueryState(), 2), search = _useSearchQueryState[0], setSearch = _useSearchQueryState[1];
    var _React_useState = _sliced_to_array(React.useState(false), 2), isSearching = _React_useState[0], setIsSearching = _React_useState[1];
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var handleLogsOptionChange = React.useCallback(function(event) {
        var webRoute = event.target.value;
        navigate(webRoute);
    }, [
        navigate
    ]);
    var outlet = useOutlet();
    if (children == null && outlet == null) {
        throw new Error('PanelLayout requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "SNuQo7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Logs"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "VaO7Y7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search through logs from the last 7 days."
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "SNuQo7",
                    defaultMessage: "Logs"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.buttonRow,
                children: [
                    /*#__PURE__*/ _jsxs(NativeSelect, {
                        variant: "outline",
                        value: pathname,
                        onChange: handleLogsOptionChange,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                value: WebRoutes.LOGS_MESSAGES,
                                children: "Messages"
                            }),
                            /*#__PURE__*/ _jsx("option", {
                                value: WebRoutes.LOGS_TIMEOUTS,
                                children: "Timeouts"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SearchInput, {
                        search: search,
                        autoFocus: true,
                        placeholder: intl.formatMessage({
                            id: "WhacQ6",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search logs..."
                                }
                            ]
                        }),
                        setSearch: setSearch,
                        isSearching: isSearching
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LogContext.Provider, {
                value: {
                    search: search,
                    setIsSearching: setIsSearching
                },
                children: children !== null && children !== void 0 ? children : outlet
            })
        ]
    });
}
